import Swiper from 'swiper';
import { Autoplay, Pagination, Keyboard } from 'swiper/modules';

import 'swiper/scss';
import 'swiper/scss/autoplay';
import 'swiper/scss/navigation';
// import 'swiper/scss/pagination';



// Hero Sliders
const heroSliders = document.querySelectorAll('[heroSlider]');

if (heroSliders.length > 0)
{
    [...heroSliders].forEach((element, index) => {
        const totalSlides = element.dataset.totalSlides;
        const loop = totalSlides > 1 ? true : false;

        const swiper = new Swiper(element, {
            modules: [Autoplay, Pagination, Keyboard],
            centeredSlides: true,
            rewind: false,
            autoHeight: true,
            loop: loop,
            speed: 800,
            autoplay: {
                delay: 28000
            },
            keyboard: {
                enabled: true
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            }
        });
    });
}